import React from "react";
import { compileDateVariable } from "../../assets/js/genericHelpers";

const PerformaceRuntimeSetting = (props) => {
  const { url, time } = props;
  return (
    <div className="py-5 mt-3">
      <h5 className="heading text-size-24 color-indigo-900 font-weight-bold mb-5">
        Runtime Settings
      </h5>
      <div className="row">
        <div className="col">
          <div className="row mt-2 mb-2">
            <div className="col-2 color-indigo-900 font-weight-bold">URL</div>
            <div className="col">{url}</div>
          </div>
          {/* <div className="row mt-2 mb-2">
            <div className="col-2 color-indigo-900 font-weight-bold">
              Location
            </div>
            <div className="col">Europe</div>
          </div> */}
          {/* <div className="row mt-2 mb-2">
            <div className="col-4 color-indigo-900 font-weight-bold">
              Network
            </div>
            <div className="col-8">Cable</div>
          </div> */}
          <div className="row mt-2 mb-2">
            <div className="col-2 color-indigo-900 font-weight-bold">
              Date and Time
            </div>
            <div className="col">{time ? `${compileDateVariable(time)}   IST` : ""}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformaceRuntimeSetting;
